import { render, staticRenderFns } from "./application-header-loader.vue?vue&type=template&id=867325a2"
import script from "./application-header-loader.vue?vue&type=script&lang=js"
export * from "./application-header-loader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports